
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"46","height":"46","rx":"8","fill":"url(#paint0_linear)"}}),_c('path',{attrs:{"d":"M19.818 30.626c0 .245.04.491.199.737l.676 1.023c.199.328.676.614 1.074.614h2.426c.398 0 .875-.286 1.074-.614l.676-1.023c.12-.205.199-.533.199-.737v-1.597h-6.324v1.597zM16 19.205c0 1.842.636 3.48 1.71 4.748.676.778 1.67 2.415 2.068 3.766v.041h6.404v-.04c.398-1.352 1.392-2.989 2.068-3.767A7.302 7.302 0 0030 19.205C30 15.234 26.818 12 22.96 12c-4.057.04-6.96 3.398-6.96 7.205zm7-3.275c-1.79 0-3.182 1.474-3.182 3.275a.664.664 0 01-.636.655.638.638 0 01-.636-.655c0-2.497 1.988-4.585 4.454-4.585.318 0 .636.327.636.655a.664.664 0 01-.636.655z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"0","y1":"0","x2":"51.265","y2":"6.904","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#01A48B"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#41BB2E"}})])])])
          )
        }
      }
    